<template>

    <div class="notification-modal" >
        <div class="notification-modal__inner">
            <ak-loader :loading="loading" />
            <h1 class="ak-popover-menu__title">{{ title }}</h1>
            <div class="notification-modal__container">
                <div class="notification-modal__loader" v-for="(message, index) in  messages" :key="index">
                    <p class="ak-data-list__item notification-modal__message" >{{ (index+1) + " - " + message }}</p>
                </div>
            </div>
            <div class="notification-modal__btn-container">
<!--                <router-link :to="{ name: 'grid', params: { gridDefinition: 'grid' , bundle: bundle }}" class="text-decoration-none">-->
<!--                    <button class="notification-modal__btn ak-button ak-button&#45;&#45;click" @click="loadMore">Details</button>-->
<!--                </router-link>-->
                <button class="notification-modal__btn ak-button ak-button--click" @click="loadMore">Load more</button>
                <button class="notification-modal__btn ak-button ak-button--click" @click="closeModal">Close</button>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'Modal',

    data(){
        return {
            pageNumber: 0,
            pageSize: 10,
            messages: [],
            notificationMessage: null,
            loading: false,
        }
    },
    props: {
        id: String,
        title: String,
    },
    methods: {
        async fetchDataMessages() {
            try {
                this.loading = true;
                const response = await this.$get(this.$getSetting('paths.baseCms') + '/notifications/messages/' + this.id, {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                });
                const newMessages= response.notificationMessage;
                this.messages = [...this.messages, ...newMessages];
                this.loading = false;

            } catch(error){
                if (error.response.status === 401) {
                    console.log('Unauthorized: Please check your authentication credentials.');
                }
                if (error.response.status === 404) {
                    console.log('404: Could not find.');
                }
                console.log('Error: Check status code', error.response.status);
                this.loading = false;
            }
        },



        loadMore() {
            this.pageNumber++;
            this.fetchDataMessages();
        },

        closeModal() {
            this.$emit('close');
        },
    },
    mounted() {
        this.fetchDataMessages();
    },
    created() {
    }
}
</script>